import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import { parseUserInfo } from '~/helpers/parseUserInfo';
import { useApi } from '~/lib/api';
import { useUserQuery } from '~/lib/api/modules/Users/hooks/useUserQuery';

export type ISentryTagsProps = Record<string, never>;

export const SentryTags: React.FC<ISentryTagsProps> = () => {
  const api = useApi();
  const userAuthorization = api.getAuthorization();
  const userQuery = useUserQuery({});
  const userInfo = userQuery.data ? parseUserInfo(userQuery.data) : undefined;
  const appRegion = userAuthorization?.region;

  useEffect(() => {
    if (userInfo) {
      Sentry.setUser({
        id: userInfo._id,
        fullName: userInfo.fullName,
        email: userInfo.emailAddress,
      });

      if (appRegion) {
        Sentry.setTag('app_region', appRegion);
      }
    }
  }, [userInfo, appRegion]);

  return null;
};
